// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"d2ee7d60","373":"ebdba90c","542":"e8d21cad","844":"d09750be"}[chunkId] + ".chunk.js";
};